import React from 'react';
import { useI18n } from 'nordic/i18n';
import PropTypes from 'prop-types';
import { Image } from 'nordic/image';
import Card, { CardContent } from '@andes/card';
import TrackingLink from '../TrackingLink';
import SharedPropsContext from '../../contexts/SharedProps';
import { getSellerItemContent } from '../content/sellerItem';

const SellerItem = ({ seller, fontWhite, melidataEvent, analyticsEvent }) => {
  const { apiPicture } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const { until, off } = getSellerItemContent({ i18n });

  const { url, id, image, name, promotion } = seller;

  const { url: urlImage, fileExtension } = apiPicture;

  const melidataTrack = {
    ...melidataEvent,
    event_data: {
      seller_id: id,
    },
  };


  return (
    <div className={`seller-item ${promotion ? 'promotion' : ''}`}>
      <Card shadow="elevated" paddingSize={0}>
        <CardContent animated>
          <TrackingLink
            href={url}
            target="_blank"
            trackInfo={analyticsEvent}
            trackInfoMelidata={melidataTrack}
          >
            <Image
              onload="on"
              className="seller-item__image"
              src={`${urlImage + image}-Q${fileExtension}`}
              alt={name}
            />
            {promotion
              && (
              <div className="seller-item__promotion">
                <div className="seller-item__promotion-until">{until}</div>
                <div className="seller-item__promotion-percentage">{`${promotion.title}%`}&nbsp;</div>
                <div className="seller-item__promotion-off">{off}</div>
              </div>
              )}
          </TrackingLink>
        </CardContent>
      </Card>
      <div className={`seller-item__name ${fontWhite ? 'font-white' : 'font-black'}`}>
        {name.toUpperCase()}
      </div>
    </div>
  );
};

SellerItem.propTypes = {
  seller: PropTypes.shape({
    url: PropTypes.string,
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    promotion: PropTypes.shape({
      title: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
    }),
  }).isRequired,
  fontWhite: PropTypes.bool.isRequired,
  melidataEvent: PropTypes.shape({
    path: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
  analyticsEvent: PropTypes.shape({
    hitType: PropTypes.string.isRequired,
    eventCategory: PropTypes.string.isRequired,
    eventAction: PropTypes.string.isRequired,
    eventLabel: PropTypes.string.isRequired,
  }),
};

SellerItem.defaultProps = {
  seller: {},
  melidataEvent: {},
  analyticsEvent: {},
};

export default SellerItem;
